var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "small-12 columns" }, [
    _c("h1", { staticClass: "list-title" }, [_vm._v(_vm._s(_vm.titulo))]),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass:
          "small-block-grid-1 medium-block-grid-2 large-block-grid-4 property-list imoveis-destaque"
      },
      _vm._l(_vm.imoveis, function(imovel) {
        return _c("Imovel", {
          key: imovel,
          attrs: { placa: imovel, finalidade: _vm.finalidade }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }